import { getReceivers, getMessages } from '@/api/ertebat'
export default {
    state: {
        receivers: [],
        messages: [],
        last: {},

    },

    mutations: {

        SET_RECEIVERS: (state, data) => {
            state.receivers = data
        },
        SET_ERTEBAT_MESSAGES: (state, data) => {
            state.messages = data
        },
        // SET_LAST_KHOROOJ: (state, data) => {
        //   state.last = data
        // }

    },

    actions: {
        getReceivers({ commit }) {

            return new Promise((resolve, reject) => {
                getReceivers().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_RECEIVERS', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getErtebatMessages({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getMessages().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_ERTEBAT_MESSAGES', data)
                    commit('SET_TABLE_TEXT', false)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}